import { render, staticRenderFns } from "./Inzameling.vue?vue&type=template&id=62d34f7a&scoped=true"
import script from "./Inzameling.vue?vue&type=script&lang=js"
export * from "./Inzameling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d34f7a",
  null
  
)

export default component.exports